import React from "react";
import {
  People,
  Person,
  RequestQuote,
  Work,
  ManageAccounts,
  Paid,
  Lock,
  Dashboard,
  LocalAtm,
  Assessment,
  Receipt,
  PersonAddAlt,
  CurrencyExchange,
  ReceiptLong
} from "@mui/icons-material";

import {
  USER,
  PORTFOLIO,
  CLIENT,
  VENDOR,
  TAX,
  SERVICE,
  ROLE,
  HOME,
  REPORT,
  INVOICE,
  CASH_BOOK,
  CHEQUE_BOOK,
  EXPENSE,
  BILL,
} from "@jumbo/constants/routes";

const menus = [
  {
    label: "Home",
    type: "section",
    children: [
      {
        uri: HOME,
        label: "Dashboard",
        type: "nav-item",
        icon: <Dashboard sx={{ fontSize: 20 }} />,
      },
    ],
  },

  {
    label: "Apps",
    type: "section",
    children: [
      {
        uri: CLIENT,
        label: "Clients",
        type: "nav-item",
        icon: <People sx={{ fontSize: 20 }} />,
      },
      {
        uri: VENDOR,
        label: "Vendor",
        type: "nav-item",
        icon: <PersonAddAlt sx={{ fontSize: 20 }} />,
      },
      {
        uri: INVOICE,
        label: "Invoice",
        type: "nav-item",
        icon: <Receipt sx={{ fontSize: 20 }} />,
      },
      {
        uri: BILL,
        label: "Bill",
        type: "nav-item",
        icon: <ReceiptLong sx={{ fontSize: 20 }} />,
      },
      {
        uri: CASH_BOOK,
        label: "Cash Book",
        type: "nav-item",
        icon: <Paid sx={{ fontSize: 20 }} />,
      },
      {
        uri: CHEQUE_BOOK,
        label: "Cheque Book",
        type: "nav-item",
        icon: <LocalAtm sx={{ fontSize: 20 }} />,
      },
      {
        uri: EXPENSE,
        label: "Expense",
        type: "nav-item",
        icon: <CurrencyExchange sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: REPORT,
      //   label: "Report",
      //   type: "nav-item",
      //   icon: <Assessment sx={{ fontSize: 20 }} />,
      // },
      {
        uri: PORTFOLIO,
        label: "Portfolio",
        type: "nav-item",
        icon: <Work sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "Settings",
    type: "section",
    children: [
      {
        uri: USER,
        label: "Users",
        type: "nav-item",
        icon: <Person sx={{ fontSize: 20 }} />,
      },
      {
        uri: ROLE,
        label: "Roles & Permissions",
        type: "nav-item",
        icon: <Lock sx={{ fontSize: 20 }} />,
      },
      {
        uri: TAX,
        label: "Taxes",
        type: "nav-item",
        icon: <RequestQuote sx={{ fontSize: 20 }} />,
      },
      {
        uri: SERVICE,
        label: "Services",
        type: "nav-item",
        icon: <ManageAccounts sx={{ fontSize: 20 }} />,
      },
    ],
  },
];

export default menus;
